/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getHead'

export { $nsid }

/** @deprecated please use com.atproto.sync.getLatestCommit instead */
const main = l.query(
  $nsid,
  l.params({ did: l.string({ format: 'did' }) }),
  l.jsonPayload({ root: l.string({ format: 'cid' }) }),
  ['HeadNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
